// assets
import {
    IconKey,
    IconSettings,
    IconChartBar,
    IconUsers,
    IconUsersGroup,
    IconBuildingHospital,
    IconBook,
    IconDiscountCheck,
    IconBook2,
    IconMail,
    IconNotes,
    IconHistory,
    IconFileText
} from '@tabler/icons-react';
import { NavItemType } from '../types';

// constant
const icons = {
    IconKey,
    IconSettings,
    IconChartBar,
    IconBuildingHospital,
    IconUsers,
    IconUsersGroup,
    IconBook,
    IconBook2,
    IconDiscountCheck,
    IconMail,
    IconNotes,
    IconHistory,
    IconFileText
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const adminHospitalsNavItems: NavItemType[] = [
    {
        id: 'admin-hospitals',
        title: 'Hospitals',
        type: 'item',
        url: '/admin/hospitals',
        icon: icons.IconBuildingHospital,
        breadcrumbs: false
    },
    {
        id: 'admin-all-users',
        title: 'All Users',
        type: 'item',
        url: '/admin/users',
        icon: icons.IconUsers,
        breadcrumbs: false
    },
    {
        id: 'admin-user-associations',
        title: 'User Associations',
        type: 'item',
        url: '/admin/user-associations',
        icon: icons.IconUsers,
        breadcrumbs: false
    },
    {
        id: 'admin-reports-dashboards',
        title: 'Reports & Dashboards',
        type: 'item',
        url: '/admin/reports-dashboards',
        icon: icons.IconChartBar,
        breadcrumbs: false
    },
    // {
    //     id: 'admin-knowledge-base',
    //     title: 'Knowledge Base',
    //     type: 'item',
    //     url: '/admin/knowledge-base',
    //     icon: icons.IconBook,
    //     breadcrumbs: false
    // },
    {
        id: 'admin-activity-logs',
        title: 'Audit logs',
        type: 'item',
        url: '/activity-logs',
        icon: icons.IconHistory,
        breadcrumbs: false
    }
    // {
    //     id: 'admin-meeting-transcription',
    //     title: 'Meeting Transcription',
    //     type: 'item',
    //     url: '/admin/meeting-transcription',
    //     icon: icons.IconFileText,
    //     breadcrumbs: false
    // }
];

const getHospitalContextNavItems = (): NavItemType[] => [
    {
        id: 'hospital-handoff',
        title: 'Handoff',
        type: 'item',
        url: '/admin/hospitals/:hospitalId/dashboard',
        icon: icons.IconChartBar,
        breadcrumbs: false
    },
    {
        id: 'hospital-detail',
        title: 'Hospital Detail',
        type: 'item',
        url: '/admin/hospitals/:hospitalId/hospital-details',
        icon: icons.IconBuildingHospital,
        breadcrumbs: false
    },
    {
        id: 'hospital-manage-mapping',
        title: 'Manage Mapping',
        type: 'item',
        url: '/admin/hospitals/:hospitalId/manage-mapping',
        icon: icons.IconSettings,
        breadcrumbs: false
    },
    // {
    //     id: 'hospital-population-scope',
    //     title: 'Population Scope',
    //     type: 'item',
    //     url: '/admin/hospitals/:hospitalId/population-scope',
    //     icon: icons.IconDiscountCheck,
    //     breadcrumbs: false
    // },
    {
        id: 'hospital-manage-patients',
        title: 'Manage Patients',
        type: 'item',
        url: '/admin/hospitals/:hospitalId/manage-patients',
        icon: icons.IconUsers,
        breadcrumbs: false
    },
    {
        id: 'hospital-census',
        title: 'Census',
        type: 'item',
        url: '/admin/hospitals/:hospitalId/census',
        icon: icons.IconChartBar,
        breadcrumbs: false
    },
    {
        id: 'hospital-assigned-patients',
        title: 'CCM',
        caption: 'Complex Case Management',
        type: 'item',
        url: '/admin/hospitals/:hospitalId/my-patients',
        icon: icons.IconNotes,
        breadcrumbs: false
    },
    {
        id: 'hospital-meeting-view',
        title: 'Meeting View',
        type: 'item',
        url: '/admin/hospitals/:hospitalId/meeting-view',
        icon: icons.IconUsersGroup,
        breadcrumbs: false
    },
    {
        id: 'hospital-meeting-transcription',
        title: 'Meeting Transcription',
        type: 'item',
        url: '/admin/hospitals/:hospitalId/meeting-transcription',
        icon: icons.IconFileText,
        breadcrumbs: false
    },
    {
        id: 'hospital-performance-scorecard',
        title: 'Performance Scorecard',
        type: 'item',
        url: '/admin/hospitals/:hospitalId/scorecard',
        icon: icons.IconUsersGroup,
        breadcrumbs: false
    },
    {
        id: 'hospital-manage-staff',
        title: 'Manage Staff',
        type: 'item',
        url: '/admin/hospitals/:hospitalId/manage-staff',
        icon: icons.IconUsers,
        breadcrumbs: false
    },
    {
        id: 'hospital-static-subscribers',
        title: 'Static Subscribers',
        type: 'item',
        url: '/admin/hospitals/:hospitalId/static-subscribers',
        icon: icons.IconMail,
        breadcrumbs: false
    },
    {
        id: 'admin-dart-report',
        title: 'DARt',
        caption: 'Discharge Acceleration Report',
        type: 'item',
        url: '/admin/hospitals/:hospitalId/dart-report',
        icon: icons.IconChartBar,
        breadcrumbs: false
    },
    {
        id: 'hospital-insights',
        title: 'Insights',
        type: 'item',
        url: '/admin/hospitals/:hospitalId/insights',
        icon: icons.IconChartBar,
        breadcrumbs: false
    },
    {
        id: 'hospital-config',
        title: 'Hospital Config Pane',
        type: 'item',
        url: '/admin/hospitals/:hospitalId/hospital-config',
        icon: icons.IconSettings,
        breadcrumbs: false
    }
    // {
    //     id: 'hospital-data-dictionary',
    //     title: 'Data Dictionary',
    //     type: 'item',
    //     url: '/admin/hospitals/:hospitalId/data-dictionary',
    //     icon: icons.IconBook2,
    //     breadcrumbs: false
    // },
    // {
    //     id: 'hospital-playbooks',
    //     title: 'Playbooks',
    //     type: 'item',
    //     url: '/admin/hospitals/:hospitalId/playbooks',
    //     icon: icons.IconBook,
    //     breadcrumbs: false
    // }
];

type PagesMenuOptions = {
    hospitalId?: string;
    hideWeekendHandoff?: boolean;
    showStaticSubscribers?: boolean;
};

export const getPagesMenu = ({
    hospitalId,
    hideWeekendHandoff = false,
    showStaticSubscribers = false
}: PagesMenuOptions = {}): NavItemType => {
    const hospitalContextNavItems = getHospitalContextNavItems();
    let visibleHospitalContextNavItems = hideWeekendHandoff
        ? hospitalContextNavItems.filter((item) => item.id !== 'hospital-handoff')
        : hospitalContextNavItems;

    if (!showStaticSubscribers) {
        visibleHospitalContextNavItems = visibleHospitalContextNavItems.filter((item) => item.id !== 'hospital-static-subscribers');
    }

    if (hospitalId) {
        return {
            id: 'pages',
            icon: icons.IconKey,
            type: 'group',
            children: visibleHospitalContextNavItems.map((item) => ({
                ...item,
                url: item.url?.replace(':hospitalId', hospitalId)
            }))
        };
    }

    return {
        id: 'pages',
        icon: icons.IconKey,
        type: 'group',
        children: adminHospitalsNavItems
    };
};

const pages: NavItemType = getPagesMenu();

export default pages;
